import React, { Component } from "react";

export default class ContactPages extends Component {
  render() {
    return (
      <section className="container">
        <div className="centertext">
          <h1 className="title">Kontakt os...</h1>
          <div className="content-text">
            Åbningstider: <br />
            Mandag - Tordag: 16.00 - 22.30 <br />
            Fredag: 16.00 - 02.00 <br />
            Lørdag: 12.00 - 02.00 <br />
            Søndag: 12.00 - 21.30 <br />
            <br />
            Telefon nr.: 33 24 83 00 <br />
            Adresse: Enghavevej 28A <br />
            1674 København V. <br />
          </div>
        </div>
      </section>
    );
  }
}
